import { computed, watch } from 'vue'

import { useCookie, useRuntimeConfig, useNuxtApp } from '#app'

const TOKEN_SECONDS = 60 * 60 * 24

export const useAuthToken = () => {
  const nuxtApp = useNuxtApp()
  const { clientId } = useRuntimeConfig().public

  const isProduction = import.meta.env.MODE === 'production'

  // Cache cookie refs in nuxtApp instance (SSR-safe, per-request isolation)
  if (!nuxtApp._authTokenRefs) {
    nuxtApp._authTokenRefs = {
      tokenA: useCookie(`cuora_${clientId}-a`, {
        default: () => null,
        maxAge: TOKEN_SECONDS,
        secure: isProduction,
        sameSite: 'lax',
      }),
      tokenB: useCookie(`cuora_${clientId}-b`, {
        default: () => null,
        maxAge: TOKEN_SECONDS,
        secure: isProduction,
        sameSite: 'lax',
      }),
    }
  }

  const { tokenA, tokenB } = nuxtApp._authTokenRefs

  const token = computed(() => {
    return tokenA.value || tokenB.value
  })

  const isLoggedIn = computed(() => {
    return !!token.value
  })

  const isGuest = computed(() => {
    return !token.value
  })

  const setToken = (newToken) => {
    tokenA.value = newToken
  }

  const extendToken = () => {
    if (tokenA.value) {
      tokenB.value = tokenA.value
      tokenA.value = null
    } else {
      tokenA.value = tokenB.value
      tokenB.value = null
    }
  }

  const clearToken = () => {
    tokenA.value = null
    tokenB.value = null
  }

  const getAuthHeaders = () => {
    return token.value
      ? {
          Authorization: `Bearer ${token.value}`,
        }
      : {}
  }

  return {
    token,
    isLoggedIn,
    isGuest,
    setToken,
    clearToken,
    extendToken,
    getAuthHeaders,
  }
}
